import { useState, useCallback } from "react";
import { DealerContextProps } from "./context";
import { Dealer, CoopInfo } from "@/interfaces";

export const useDealerContextController = (): DealerContextProps => {
  const [dealerValue, setDealerValue] = useState<Dealer | undefined>();
  const [coopInfoValue, setCoopInfoValue] = useState<CoopInfo | undefined>();

  const setDealer = useCallback(
    (dealer?: Dealer) => {
      setDealerValue(dealer);
    },
    [setDealerValue]
  );

  const setCoopInfo = useCallback(
    (coopInfo?: CoopInfo) => {
      setCoopInfoValue(coopInfo);
    },
    [setCoopInfoValue]
  );

  const setNewSession = useCallback(() => {
    setDealerValue(undefined);
    setCoopInfoValue(undefined);
  }, [setDealerValue, setCoopInfoValue]);

  return {
    dealer: dealerValue,
    setDealer,
    coopInfo: coopInfoValue,
    setCoopInfo,
    setNewSession,
  };
};
